const MyAppraisals = () => import("./views/MyAppraisals.vue");
const AnAppraisalDetailsView = () =>
  import("./views/AnAppraisalDetailsView.vue");
const AppraiseTemplate = () => import("./views/AppraiseTemplate.vue");
const Appraise = () => import("./views/Appraise.vue");
export const tabLinks = [
  {
    label: "My Appraisal",
    url: "/ess/hrm/appraisal/my-appraisals",
  },
  {
    label: "Appraise",
    url: "/ess/hrm/appraisal/appraise",
  },
];
export default [
  {
    path: "my-appraisals",
    component: MyAppraisals,
  },
  {
    path: "my-appraisals/view-appraisal/:id",
    component: AnAppraisalDetailsView,
  },
  {
    path: "my-appraisals/self-appraise/:id",
    component: AppraiseTemplate,
  },
  {
    path: "appraise",
    component: Appraise,
  },
  {
    path: "appraise/view-appraisal/1",
    component: AnAppraisalDetailsView,
  },
  {
    path: "appraise/1",
    component: AppraiseTemplate,
  },
];
